import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyImport, LazyAction, registerLazyOrchestrator } from 'owa-bundling';
import { onAfterSelectionChanged } from 'owa-mail-actions/lib/mailListSelectionActions';

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "FocusedOverride"*/ './lazyIndex'),
    { name: 'FocusedOverride' }
);

export const lazyIsFocusedOverridden: LazyImport<
    typeof lazyIndex.isFocusedOverridden,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.isFocusedOverridden);

/**
 * Fetches the InferenceClassificationResult ("focused override") flag for the
 * latest item in the given row, if it isn't already cached. Designed to be
 * invoked on demand when a Move surface opens for a Focused-inbox row.
 *
 * No-ops when the `tri-focusedInboxOverride-ondemand` flight is off (the legacy
 * eager orchestrator owns the fetch in that mode). Safe to call from menu-open
 * hooks unconditionally.
 */
export const lazyEnsureFocusedOverrideLoaded: LazyAction<
    typeof lazyIndex.ensureFocusedOverrideLoaded,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.ensureFocusedOverrideLoaded);

// Legacy eager fetch path. The orchestrator early-returns when the
// `tri-focusedInboxOverride-ondemand` flight is on, so the menu-open hooks
// can own the fetch. Delete this registration once the flight is at 100%.
registerLazyOrchestrator(
    onAfterSelectionChanged,
    lazyModule,
    m => m.getFocusedOverrideOrchestrator
);
